<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div v-if="this.perguntas.length > 0">
      <div v-if="showQuestions">
        <div class="tit">
          <h1>Antes de prosseguirmos, só preciso que responda algumas perguntas.</h1>
        </div>
        <form>
          <div v-for="(pergunta, indicePergunta) in perguntas" v-if="indicePergunta == perguntaAtual">
            <div class="tit">
              <p>{{indicePergunta + 1}} - {{pergunta.Question}}</p>
            </div>
            <div class="row justify-content-center">
              <div class="col-12">
                <ul class="list-group text-left">
                  <li class="list-group-item" v-for="resposta in pergunta.Answers">
                    <div class="form-check">
                      <div class="checkContainer">
                        <input class="form-check-input" @click="perguntaAtual += 1" v-model="respostas[indicePergunta]" :value="resposta" :name="`respostas[${indicePergunta}]`" type="radio">
                        <span class="checkmark"></span>
                        <label class="form-check-label" for="resposta">
                          {{resposta}}
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </form>
      </div>
      <p v-else>Aguarde um momento, estamos verificando suas respostas...</p>
    </div>
  </div>
</template>

<script>
  import HubConsultaClient from '../../utils/hub-consulta-client'
  import * as mutationTypes from '@/store/mutation-types.js'

  export default {
    data() {
      return {
        cpf: this.solicitacao.Solicitante.Cpf,
        ticketId: null,
        perguntas: [],
        perguntaAtual: 0,
        respostas: []
      }
    },
    props: {
      solicitacao: {required: true, type: Object}
    },
    computed: {
      showQuestions: function() { return this.respostas.length < this.perguntas.length }
    },
    created() {
      this.$store.commit(mutationTypes.START_LOADING)
      HubConsultaClient.pegarPerguntas(this.cpf)
        .then(data => {
          this.ticketId = data.DadosConsulta.TicketId
          this.perguntas = data.DadosConsulta.Questions
          this.$store.commit(mutationTypes.STOP_LOADING)
        })
        .catch(error => {
          this.$store.commit(mutationTypes.STOP_LOADING)
          this.$emit('on-submit', {
            ErroAoConfirmarIdentidade: error.message
          })
        })
    },
    updated() {
      if(this.respostas.length == this.perguntas.length) {
        this.$emit('on-submit', {
          TicketId: this.ticketId,
          Parameters: this.respostas
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/ConfirmacaoIdentidadePasso.vue